module.exports = __webpack_public_path__ + "img/defaultProductIco.efd435ca.png";